import React from 'react';
import { Typography } from '@ghq-abi/design-system-v2';

interface FormFieldErrorProps {
  error?: string | string[] | object;
  touched?: boolean;
  className?: string;
}

export function FormFieldError({
  error,
  touched = true,
  className = ''
}: FormFieldErrorProps) {
  // Não renderiza se não há erro ou se o campo não foi tocado
  if (!error || !touched) {
    return null;
  }

  // Função recursiva para extrair mensagens de erro de objetos aninhados
  const extractErrorMessages = (err: unknown): string[] => {
    if (typeof err === 'string') {
      return [err];
    }

    if (Array.isArray(err)) {
      return err.flatMap(item => extractErrorMessages(item));
    }

    if (typeof err === 'object' && err !== null) {
      return Object.values(err).flatMap(value => extractErrorMessages(value));
    }

    return [];
  };

  const errorMessages = extractErrorMessages(error).filter(
    msg => typeof msg === 'string' && msg.trim() !== ''
  );

  if (errorMessages.length === 0) {
    return null;
  }

  return (
    <div className={`space-y-1 mt-1 ${className}`}>
      {errorMessages.map((msg, index) => (
        <Typography
          key={index}
          variant="metadata-sm-regular"
          color="default"
          className="text-red-600 flex items-center gap-1">
          <span className="text-red-500">•</span>
          {msg}
        </Typography>
      ))}
    </div>
  );
}
